import React, { type ReactNode } from 'react';

import StatusErrorIcon from '@atlaskit/icon/core/status-error';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline } from '@atlaskit/primitives/inline';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';
import { token } from '@atlaskit/tokens';

const errorMessageWrapperStyles = xcss({
	display: 'flex',
	alignItems: 'flex-start',
	gap: 'space.050',
});

const errorMessageTextStyles = xcss({
	font: 'font.body.small',
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- the rule does not yet recognise @atlaskit/primitives subpath entry points
	color: 'color.text.accent.red',
});

export const FormFieldErrorMessage = ({ children }: { children: ReactNode }): React.JSX.Element => (
	<Box xcss={errorMessageWrapperStyles}>
		<StatusErrorIcon label="" color={token('color.icon.accent.red')} />
		<Inline xcss={errorMessageTextStyles}>{children}</Inline>
	</Box>
);
